<div class="row">
  <div class="col-12" [ngClass]="{'col-md-6': budgetFund?.length==1,'col-md-12': budgetFund?.length>1}">

    <h1 class="page-header"><i class="fas fa-hotel"></i> Departamentos </h1>

  </div>
  @if(budgetFund?.length>1){
  <div class="col-12  mb-3" [ngClass]="{'col-md-6': budgetFund?.length>1}">

    <div class="btn-group">
      @for(f of budgetFund; track f.id){
      <button class="btn btn-white btn-sm" [ngStyle]="{'min-width': '120px'}" [class.active]="fundSelect ==f.fundCode"
        (click)="changeFund(f.fundCode)">Fondo {{f.fundCode}}</button>
      }
    </div>
  </div>
  }

  <div class="col-12 col-md-6">
    <div class=" d-md-flex fw-bold justify-content-end">
      <div class="mt-3">
        <div class="ms-md-4 mt-md-0 mt-e dropdown-toggle">
          <a href="javascript:;" data-bs-toggle="dropdown" class="text-decoration-none text-dark text-opacity-75"><i
              class="fa fa-cog fa-fw me-1 text-dark text-opacity-50"></i> Opciones<b class="caret"></b></a>

          <div class="dropdown-menu">
            <a href="javascript:;" class="dropdown-item">Exportar Excel</a>
            <div role="separator" class="dropdown-divider"></div>

            <a class="dropdown-item">Configurar Departamento</a>


          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="row">
  <div class="col-12 col-md-7">
    <div class="panel p-4">
      <h5>Departamentos Configurados</h5>
      <div class="table-responsive table-data mt-2">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
            <th class="text-nowrap" style="width: 100px;">N° Código</th>
            <th>Subdepartamento</th>
            <th class="text-nowrap text-center"><i class="fas fa-cog"></i></th>
          </tr>
        </thead>

        @for (group of groupedDepartments; track group.parentCode) {
        <tbody>
          <tr class="table-group-header">
            <td colspan="3" class="fw-bold">
             DEPARTAMENTO {{ group.parentName }}
            </td>
          </tr>

          @for (sub of group.departments; track sub.departamentCode) {
          <tr>
            <td class="text-nowrap align-middle" style="height: 34px;">{{ sub.departamentCode }}</td>
            <td class="align-middle">{{ sub.displayName }}</td>
            <td class="text-nowrap">
              <div class="d-flex gap-1 justify-content-center">
                <button class="btn btn-outline-danger btn-xs" (click)="deleteDepartament(sub)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
          }

          @empty {
          <tr>
            <td colspan="3" class="text-muted">Sin subdepartamentos.</td>
          </tr>
          }
        </tbody>
        }

        @empty {
        <tbody>
          <tr>
            <td colspan="3" class="text-center">No hay departamentos para mostrar.</td>
          </tr>
        </tbody>
        }
      </table>
    </div>
    </div>
  </div>
  
  <div class="col-12 col-md-5">
    <div class="panel p-4">
      <h5>Agregar Departamentos</h5>
      <ng-select [items]="departament" [hideSelected]="true" [(ngModel)]="selected" [closeOnSelect]="false" [clearable]="false"
        [multiple]="true" bindLabel="nameCode" groupBy="parentName" [selectableGroup]="false" placeholder="Seleccione un departamento"
        [selectableGroupAsModel]="false" bindValue="departamentCode" (add)="addDepartament($event)" 
        (blur)="blurNgSelect()">
      </ng-select>
    </div>
  </div>
</div>

  <br>



  <ng-template #modal_account let-c="close" let-d="dismiss" let-modal>
    <div class="modal-header">
      <h5 class="modal-title">{{titleModal}}</h5>
      <button (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="7">
        <span></span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="formDepartamentPlan">

        <div class="form-group row">
          <label class="col-md-4 col-form-label">Código</label>
          <div class="col-md-8">
            <ng-select #ngSelect [hideSelected]="true" [items]="departament" bindLabel="nameCode" [closeOnSelect]="true"
              [dropdownPosition]="'bottom'" bindValue="departamentCode" placeholder="Escribe un departamento o codigo"
              formControlName="departamentCode" name="departamentCode" tabindex="1" (close)="closeNgSelect(ngSelect)">
            </ng-select>
            @if(formDepartamentPlan.get('departamentCode')?.errors?.required &&
            formDepartamentPlan.get('departamentCode').touched){
            <div><small class="text-danger">Cuenta es requerida.</small></div>
            }
          </div>
        </div>&nbsp;
        <div class="form-group row">
          <label class="col-md-4 col-form-label">Nombre para mostrar</label>
          <div class="col-md-8">
            <input type="text" #nameInput class="form-control" tabindex="2"
              [class.is-invalid]="formDepartamentPlan.get('displayName').invalid&&formDepartamentPlan.get('displayName').touched"
              (click)="formDepartamentPlan.get('displayName').markAsUntouched();"
              (focus)="formDepartamentPlan.get('displayName').markAsUntouched();" formControlName="displayName"
              name="displayName" class="form-control" tabindex="2" />
            @if(formDepartamentPlan.get('displayName')?.errors?.required &&
            formDepartamentPlan.get('displayName').touched){
            <div><small class="text-danger">Campo es requerido.</small></div>
            }
          </div>
        </div>&nbsp;

      </form>
    </div>
    <div class="modal-footer">
      @if(formDepartamentPlan.errors){
      <div><small class="text-danger">{{formDepartamentPlan.errors | json }}</small></div>
      }
      <button type="button" class="btn btn-secondary btn-sm" (click)="d('Cross click'); resetForm()"><i
          class="fas fa-times"></i>&nbsp; Cerrar</button>
      @if(titleModal=='Editar Departamento'){

      <button type="button" class="btn btn-primary btn-sm" (click)="submitUpdate()" tabindex="6"><i
          class="fas fa-save"></i>&nbsp;Guardar</button>
      }
      @else{
      <button type="button" class="btn btn-primary btn-sm" (click)="submitNewDepartament()" tabindex="6"><i
          class="fas fa-save"></i>&nbsp;Guardar</button>
      }


    </div>

  </ng-template>